import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { ARTIFACT_CACHE_BYTES, MAX_ATTENTION_ITEMS, MAX_EXECUTION_JSON_BYTES, MAX_LOG_TEXT_BYTES } from '../config';
import { BlobByteSource, HttpByteSource } from '../pack/byte-source';
import { extractEvidenceFromArtifact, fetchGhArtifactPack } from './gh-artifact';
import { parseCoverage } from '../model/coverage';
import { ByteBudgetLru } from '../pack/entry-cache';
import { isAbort, PackError } from '../pack/errors';
import { MeteredByteSource } from '../pack/metered';
import { openPackZip } from '../pack/zip';
import { parseExecution } from '../model/execution';
import { parseHar } from '../model/har';
import { splitNdjsonLines } from '../model/ndjson';
import { listLogs, listObjectiveOutcomes, readDatasetInfo, listSteps, listStepShots, parseActionCursors, parseFailureDetail, parseFailureIndex, parseRunManifest, parseTestResult, readAttention as _readAttention, toRunVM, toTestRow } from '../model/parse';
/** Fill mobile (surface:"native") step cursor coordinates from the actions
 * log — additive; never throws (only aborts propagate). Shared by the detail
 * bundle and the background step stream. */
function enrichStepCursors(_x, _x2, _x3, _x4) {
  return _enrichStepCursors.apply(this, arguments);
}
function _enrichStepCursors() {
  _enrichStepCursors = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee18(pack, testId, stepInfos, signal) {
    var enrichable, logRefs, actionRefs, byAction, _iterator4, _step4, ref, rel, size, text, _iterator6, _step6, a, _iterator5, _step5, info, _a, _t3, _t4, _t5;
    return _regeneratorRuntime.wrap(function (_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          enrichable = function enrichable(i) {
            return i.surface === 'native' && !!i.actionId && !i.coordinates;
          };
          if (stepInfos.some(enrichable)) {
            _context18.next = 1;
            break;
          }
          return _context18.abrupt("return");
        case 1:
          _context18.prev = 1;
          _context18.next = 2;
          return listLogs(pack, testId);
        case 2:
          logRefs = _context18.sent;
          actionRefs = logRefs.filter(function (l) {
            return /(^|-)actions\.ndjson$/.test(l.file);
          });
          byAction = new Map();
          _iterator4 = _createForOfIteratorHelper(actionRefs);
          _context18.prev = 3;
          _iterator4.s();
        case 4:
          if ((_step4 = _iterator4.n()).done) {
            _context18.next = 9;
            break;
          }
          ref = _step4.value;
          rel = "tests/".concat(testId, "/logs/").concat(ref.file);
          size = pack.entrySize(rel);
          if (!(size !== null && size > MAX_LOG_TEXT_BYTES)) {
            _context18.next = 5;
            break;
          }
          return _context18.abrupt("continue", 8);
        case 5:
          _context18.next = 6;
          return pack.readText(rel, {
            signal: signal
          });
        case 6:
          text = _context18.sent;
          if (!(text === null)) {
            _context18.next = 7;
            break;
          }
          return _context18.abrupt("continue", 8);
        case 7:
          _iterator6 = _createForOfIteratorHelper(parseActionCursors(text));
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              a = _step6.value;
              byAction.set(a.actionId, a);
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        case 8:
          _context18.next = 4;
          break;
        case 9:
          _context18.next = 11;
          break;
        case 10:
          _context18.prev = 10;
          _t3 = _context18["catch"](3);
          _iterator4.e(_t3);
        case 11:
          _context18.prev = 11;
          _iterator4.f();
          return _context18.finish(11);
        case 12:
          _iterator5 = _createForOfIteratorHelper(stepInfos);
          _context18.prev = 13;
          _iterator5.s();
        case 14:
          if ((_step5 = _iterator5.n()).done) {
            _context18.next = 18;
            break;
          }
          info = _step5.value;
          if (enrichable(info)) {
            _context18.next = 15;
            break;
          }
          return _context18.abrupt("continue", 17);
        case 15:
          _a = info.actionId ? byAction.get(info.actionId) : undefined;
          if (_a) {
            _context18.next = 16;
            break;
          }
          return _context18.abrupt("continue", 17);
        case 16:
          if (_a.cursor) info.coordinates = _a.cursor;
          if (!info.elementRect && _a.rect) info.elementRect = _a.rect;
          if (_a.viewport) info.cursorViewport = _a.viewport;
        case 17:
          _context18.next = 14;
          break;
        case 18:
          _context18.next = 20;
          break;
        case 19:
          _context18.prev = 19;
          _t4 = _context18["catch"](13);
          _iterator5.e(_t4);
        case 20:
          _context18.prev = 20;
          _iterator5.f();
          return _context18.finish(20);
        case 21:
          _context18.next = 23;
          break;
        case 22:
          _context18.prev = 22;
          _t5 = _context18["catch"](1);
          if (!isAbort(_t5)) {
            _context18.next = 23;
            break;
          }
          throw _t5;
        case 23:
        case "end":
          return _context18.stop();
      }
    }, _callee18, null, [[1, 22], [3, 10, 11, 12], [13, 19, 20, 21]]);
  }));
  return _enrichStepCursors.apply(this, arguments);
}
var packNameOf = function packNameOf(input) {
  if (input.kind !== 'url') return 'pack.evidence';
  try {
    var path = new URL(input.url, 'http://localhost').pathname;
    return decodeURIComponent(path.split('/').pop() || 'pack.evidence');
  } catch (_unused) {
    return 'pack.evidence';
  }
};

/** Entries whose bytes we never LRU-cache — they are parsed then dropped. */
var isYamlEntry = function isYamlEntry(rel) {
  return rel === 'run.yaml' || /^tests\/[^/]+\/result\.yaml$/.test(rel);
};

/**
 * The v1, in-thread PackClient: ByteSource → ranged zip container → parsed
 * view models. A future WorkerPackClient implements the same interface over
 * postMessage; nothing above this layer changes.
 */
export function createLocalPackClient() {
  var container = null;
  var metered = null;
  /** Materialized pack file for download (file input, or the .evidence
   * extracted from a gh-artifact); null for streamed URLs. */
  var ownedPackFile = null;
  var artifactCache = new ByteBudgetLru(ARTIFACT_CACHE_BYTES);
  var statsListeners = new Set();
  var requireContainer = function requireContainer() {
    if (!container) {
      throw new PackError('not-a-pack', 'no pack is open');
    }
    return container;
  };
  return {
    open: function open(input, opts) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var raw, name, got, manifestText, looksLikeArtifact, inner, header, testIds;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(input.kind === 'gh-artifact')) {
                _context.next = 2;
                break;
              }
              _context.next = 1;
              return fetchGhArtifactPack(input, {
                signal: opts === null || opts === void 0 ? void 0 : opts.signal,
                entry: input.entry,
                onStats: function onStats(s) {
                  var _iterator = _createForOfIteratorHelper(statsListeners),
                    _step;
                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      var cb = _step.value;
                      cb(s);
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                }
              });
            case 1:
              got = _context.sent;
              ownedPackFile = {
                blob: got.blob,
                name: got.entryName
              };
              raw = new BlobByteSource(got.blob);
              name = got.entryName;
              _context.next = 3;
              break;
            case 2:
              if (input.kind === 'file') {
                ownedPackFile = {
                  blob: input.file,
                  name: input.file.name
                };
                raw = new BlobByteSource(input.file);
                name = input.file.name;
              } else {
                raw = new HttpByteSource(input.url);
                name = packNameOf(input);
              }
            case 3:
              metered = new MeteredByteSource(raw, function (s) {
                var _iterator2 = _createForOfIteratorHelper(statsListeners),
                  _step2;
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    var cb = _step2.value;
                    cb(s);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
              });
              _context.next = 4;
              return openPackZip(metered, name, opts);
            case 4:
              container = _context.sent;
              _context.next = 5;
              return container.readManifest(opts);
            case 5:
              manifestText = _context.sent;
              looksLikeArtifact = manifestText === null && input.kind === 'file' && container.listEntries().some(function (e) {
                return e.name.toLowerCase().endsWith('.evidence');
              });
              if (!(looksLikeArtifact && input.kind === 'file')) {
                _context.next = 9;
                break;
              }
              _context.next = 6;
              return extractEvidenceFromArtifact(container, input.file.name, {
                entry: input.entry
              });
            case 6:
              inner = _context.sent;
              ownedPackFile = {
                blob: inner.blob,
                name: inner.entryName
              };
              raw = new BlobByteSource(inner.blob);
              metered = new MeteredByteSource(raw, function (s) {
                var _iterator3 = _createForOfIteratorHelper(statsListeners),
                  _step3;
                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var cb = _step3.value;
                    cb(s);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
              });
              _context.next = 7;
              return openPackZip(metered, inner.entryName, opts);
            case 7:
              container = _context.sent;
              _context.next = 8;
              return container.readManifest(opts);
            case 8:
              manifestText = _context.sent;
            case 9:
              if (!(manifestText === null)) {
                _context.next = 10;
                break;
              }
              throw new PackError('not-a-pack', 'this archive has no top-level run.yaml — not an evidence pack');
            case 10:
              header = toRunVM(parseRunManifest(manifestText));
              _context.next = 11;
              return container.listTestIds();
            case 11:
              testIds = _context.sent;
              return _context.abrupt("return", {
                header: header,
                testIds: testIds
              });
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    readTestRow: function readTestRow(id, signal) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var pack, text, row, dataset;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              pack = requireContainer();
              _context2.next = 1;
              return pack.readResult(id, {
                signal: signal
              });
            case 1:
              text = _context2.sent;
              if (!(text === null)) {
                _context2.next = 2;
                break;
              }
              throw new PackError('not-a-pack', "tests/".concat(id, "/result.yaml is missing"), {
                entry: "tests/".concat(id, "/result.yaml")
              });
            case 2:
              row = toTestRow(id, parseTestResult(text)); // Data-driven runs name their dataset row — one tiny extra read, only
              // when the central directory lists the file.
              _context2.next = 3;
              return readDatasetInfo(pack, id, signal)["catch"](function (err) {
                if (isAbort(err)) throw err;
                return null;
              });
            case 3:
              dataset = _context2.sent;
              return _context2.abrupt("return", dataset ? _objectSpread(_objectSpread({}, row), {}, {
                dataset: dataset
              }) : row);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    readCoverage: function readCoverage() {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var text, _t;
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return requireContainer().readText('coverage/usecases.yaml');
            case 1:
              text = _context3.sent;
              return _context3.abrupt("return", text === null ? null : parseCoverage(text));
            case 2:
              _context3.prev = 2;
              _t = _context3["catch"](0);
              return _context3.abrupt("return", null);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 2]]);
      }))();
    },
    readAttention: function readAttention(onIndex) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _t2;
        return _regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 1;
              return _readAttention(requireContainer(), MAX_ATTENTION_ITEMS, onIndex);
            case 1:
              return _context4.abrupt("return", _context4.sent);
            case 2:
              _context4.prev = 2;
              _t2 = _context4["catch"](0);
              return _context4.abrupt("return", null);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 2]]);
      }))();
    },
    readTestDetail: function readTestDetail(testId, signal, opts) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0;
        var pack, skipSteps, readTextCapped, readFailure, findVideo, _yield$Promise$allSet, _yield$Promise$allSet2, result, execution, steps, logs, failure, videoPath, dataset, stepInfos, logRefs;
        return _regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              pack = requireContainer(); // skipSteps: render from execution.json + result.yaml first; the many
              // per-step step.json reads stream in later via readTestSteps.
              skipSteps = (opts === null || opts === void 0 ? void 0 : opts.skipSteps) === true; // Size-guarded small-text read; content problems resolve to null.
              readTextCapped = /*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(rel, maxBytes) {
                  var size;
                  return _regeneratorRuntime.wrap(function (_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        size = pack.entrySize(rel);
                        if (!(size !== null && size > maxBytes)) {
                          _context5.next = 1;
                          break;
                        }
                        return _context5.abrupt("return", null);
                      case 1:
                        return _context5.abrupt("return", pack.readText(rel, {
                          signal: signal
                        }));
                      case 2:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function readTextCapped(_x5, _x6) {
                  return _ref.apply(this, arguments);
                };
              }();
              readFailure = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                  var _index$failures, _detail$step;
                  var indexText, index, ref, detail, text;
                  return _regeneratorRuntime.wrap(function (_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        _context6.next = 1;
                        return pack.readText('failure.yaml', {
                          signal: signal
                        });
                      case 1:
                        indexText = _context6.sent;
                        if (!(indexText === null)) {
                          _context6.next = 2;
                          break;
                        }
                        return _context6.abrupt("return", null);
                      case 2:
                        index = parseFailureIndex(indexText);
                        ref = index === null || index === void 0 || (_index$failures = index.failures) === null || _index$failures === void 0 ? void 0 : _index$failures.find(function (f) {
                          return f.test === testId;
                        });
                        if (ref) {
                          _context6.next = 3;
                          break;
                        }
                        return _context6.abrupt("return", null);
                      case 3:
                        detail = {};
                        if (!(typeof ref.path === 'string' && ref.path !== '')) {
                          _context6.next = 5;
                          break;
                        }
                        _context6.next = 4;
                        return pack.readText(ref.path, {
                          signal: signal
                        });
                      case 4:
                        text = _context6.sent;
                        if (text !== null) detail = parseFailureDetail(text);
                      case 5:
                        return _context6.abrupt("return", {
                          message: detail.message,
                          rootCause: detail.rootCause,
                          suggestedFix: detail.suggestedFix,
                          anchorStepId: (_detail$step = detail.step) !== null && _detail$step !== void 0 ? _detail$step : typeof ref.step === 'string' ? ref.step : undefined
                        });
                      case 6:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function readFailure() {
                  return _ref2.apply(this, arguments);
                };
              }(); // A pack-internal video is central-directory knowledge — free checks.
              findVideo = /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                  var _i, _arr, ext, rel;
                  return _regeneratorRuntime.wrap(function (_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        _i = 0, _arr = ['mp4', 'webm'];
                      case 1:
                        if (!(_i < _arr.length)) {
                          _context7.next = 4;
                          break;
                        }
                        ext = _arr[_i];
                        rel = "tests/".concat(testId, "/video.").concat(ext);
                        _context7.next = 2;
                        return pack.exists(rel);
                      case 2:
                        if (!_context7.sent) {
                          _context7.next = 3;
                          break;
                        }
                        return _context7.abrupt("return", rel);
                      case 3:
                        _i++;
                        _context7.next = 1;
                        break;
                      case 4:
                        return _context7.abrupt("return", null);
                      case 5:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function findVideo() {
                  return _ref3.apply(this, arguments);
                };
              }(); // Six concurrent reads; each section degrades to null independently —
              // a broken execution.json must not cost the steps/ folder scan.
              _context8.next = 1;
              return Promise.allSettled([pack.readResult(testId, {
                signal: signal
              }).then(function (text) {
                return text === null ? null : parseTestResult(text);
              }), readTextCapped("tests/".concat(testId, "/auteur/execution.json"), MAX_EXECUTION_JSON_BYTES).then(function (text) {
                return text === null ? null : parseExecution(text);
              }), skipSteps ? listStepShots(pack, testId) : listSteps(pack, testId), listLogs(pack, testId), readFailure(), findVideo(), readDatasetInfo(pack, testId, signal)]).then(function (settled) {
                var aborted = settled.find(function (s) {
                  return s.status === 'rejected' && isAbort(s.reason);
                });
                if (aborted && aborted.status === 'rejected') throw aborted.reason;
                return settled.map(function (s) {
                  return s.status === 'fulfilled' ? s.value : null;
                });
              });
            case 1:
              _yield$Promise$allSet = _context8.sent;
              _yield$Promise$allSet2 = _slicedToArray(_yield$Promise$allSet, 7);
              result = _yield$Promise$allSet2[0];
              execution = _yield$Promise$allSet2[1];
              steps = _yield$Promise$allSet2[2];
              logs = _yield$Promise$allSet2[3];
              failure = _yield$Promise$allSet2[4];
              videoPath = _yield$Promise$allSet2[5];
              dataset = _yield$Promise$allSet2[6];
              stepInfos = (_ref4 = steps) !== null && _ref4 !== void 0 ? _ref4 : [];
              logRefs = (_ref5 = logs) !== null && _ref5 !== void 0 ? _ref5 : []; // Mobile packs author click coordinates only in logs/*-actions.ndjson
              // (web step.json carries them directly) — join by action_id and fill
              // ONLY the gaps, so authored step.json values always win. Gated to
              // surface:"native" steps: on web, a step WITHOUT authored coordinates
              // means the producer deliberately omitted them (contract 2026-07-09) —
              // the actions log's visual_data there is the model's grounding guess,
              // not the executed click point, and must not be resurrected.
              if (skipSteps) {
                _context8.next = 2;
                break;
              }
              _context8.next = 2;
              return enrichStepCursors(pack, testId, stepInfos, signal);
            case 2:
              return _context8.abrupt("return", {
                result: (_ref6 = result) !== null && _ref6 !== void 0 ? _ref6 : null,
                execution: (_ref7 = execution) !== null && _ref7 !== void 0 ? _ref7 : null,
                steps: stepInfos,
                logs: logRefs,
                failure: (_ref8 = failure) !== null && _ref8 !== void 0 ? _ref8 : null,
                videoPath: (_ref9 = videoPath) !== null && _ref9 !== void 0 ? _ref9 : null,
                dataset: (_ref0 = dataset) !== null && _ref0 !== void 0 ? _ref0 : null
              });
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    readTestSteps: function readTestSteps(testId, signal) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var pack, stepInfos;
        return _regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              pack = requireContainer();
              _context9.next = 1;
              return listSteps(pack, testId);
            case 1:
              stepInfos = _context9.sent;
              _context9.next = 2;
              return enrichStepCursors(pack, testId, stepInfos, signal);
            case 2:
              return _context9.abrupt("return", stepInfos);
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    readDatasetParams: function readDatasetParams(testId, signal) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee0() {
        var _parseExecution$testP, _parseExecution;
        var pack, rel, size, text;
        return _regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              pack = requireContainer();
              rel = "tests/".concat(testId, "/auteur/execution.json");
              size = pack.entrySize(rel);
              if (!(size !== null && size > MAX_EXECUTION_JSON_BYTES)) {
                _context0.next = 1;
                break;
              }
              return _context0.abrupt("return", []);
            case 1:
              _context0.next = 2;
              return pack.readText(rel, {
                signal: signal
              });
            case 2:
              text = _context0.sent;
              return _context0.abrupt("return", text === null ? [] : (_parseExecution$testP = (_parseExecution = parseExecution(text)) === null || _parseExecution === void 0 ? void 0 : _parseExecution.testParams) !== null && _parseExecution$testP !== void 0 ? _parseExecution$testP : []);
            case 3:
            case "end":
              return _context0.stop();
          }
        }, _callee0);
      }))();
    },
    readObjectiveOutcomes: function readObjectiveOutcomes(testId, signal) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee1() {
        return _regeneratorRuntime.wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              return _context1.abrupt("return", listObjectiveOutcomes(requireContainer(), testId, signal));
            case 1:
            case "end":
              return _context1.stop();
          }
        }, _callee1);
      }))();
    },
    readLogLines: function readLogLines(rel, signal) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var pack, size, text;
        return _regeneratorRuntime.wrap(function (_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              pack = requireContainer();
              size = pack.entrySize(rel);
              if (!(size === null)) {
                _context10.next = 1;
                break;
              }
              return _context10.abrupt("return", null);
            case 1:
              if (!(size > MAX_LOG_TEXT_BYTES)) {
                _context10.next = 2;
                break;
              }
              return _context10.abrupt("return", {
                kind: 'too-large',
                totalBytes: size
              });
            case 2:
              _context10.next = 3;
              return pack.readText(rel, {
                signal: signal
              });
            case 3:
              text = _context10.sent;
              if (!(text === null)) {
                _context10.next = 4;
                break;
              }
              return _context10.abrupt("return", null);
            case 4:
              return _context10.abrupt("return", {
                kind: 'ready',
                lines: splitNdjsonLines(text),
                totalBytes: size
              });
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    readHar: function readHar(rel, signal) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var pack, size, text, har;
        return _regeneratorRuntime.wrap(function (_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              pack = requireContainer();
              size = pack.entrySize(rel);
              if (!(size === null)) {
                _context11.next = 1;
                break;
              }
              return _context11.abrupt("return", null);
            case 1:
              if (!(size > MAX_LOG_TEXT_BYTES)) {
                _context11.next = 2;
                break;
              }
              return _context11.abrupt("return", {
                kind: 'too-large',
                totalBytes: size
              });
            case 2:
              _context11.next = 3;
              return pack.readText(rel, {
                signal: signal
              });
            case 3:
              text = _context11.sent;
              if (!(text === null)) {
                _context11.next = 4;
                break;
              }
              return _context11.abrupt("return", null);
            case 4:
              har = parseHar(text);
              if (!(har === null)) {
                _context11.next = 5;
                break;
              }
              return _context11.abrupt("return", {
                kind: 'invalid'
              });
            case 5:
              return _context11.abrupt("return", {
                kind: 'ready',
                har: har,
                totalBytes: size
              });
            case 6:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    readBytes: function readBytes(rel, signal) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var pack, cached, bytes;
        return _regeneratorRuntime.wrap(function (_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              pack = requireContainer();
              if (isYamlEntry(rel)) {
                _context12.next = 1;
                break;
              }
              cached = artifactCache.get(rel);
              if (!cached) {
                _context12.next = 1;
                break;
              }
              return _context12.abrupt("return", cached);
            case 1:
              _context12.next = 2;
              return pack.readBytes(rel, {
                signal: signal
              });
            case 2:
              bytes = _context12.sent;
              if (bytes && !isYamlEntry(rel)) artifactCache.set(rel, bytes);
              return _context12.abrupt("return", bytes);
            case 3:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    entrySize: function entrySize(rel) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function (_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", requireContainer().entrySize(rel));
            case 1:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    listDir: function listDir(rel) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        return _regeneratorRuntime.wrap(function (_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", requireContainer().listDir(rel));
            case 1:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    listEntries: function listEntries() {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        return _regeneratorRuntime.wrap(function (_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt("return", requireContainer().listEntries());
            case 1:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    stats: function stats() {
      return metered ? metered.stats : null;
    },
    onStats: function onStats(cb) {
      statsListeners.add(cb);
      return function () {
        return statsListeners["delete"](cb);
      };
    },
    packFile: function packFile() {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        return _regeneratorRuntime.wrap(function (_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt("return", ownedPackFile);
            case 1:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    close: function close() {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        return _regeneratorRuntime.wrap(function (_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              container = null;
              metered = null;
              ownedPackFile = null;
              artifactCache.clear();
              statsListeners.clear();
            case 1:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }))();
    }
  };
}